export const formatCurrencyFromDecimal = (amount: number, decimalPlaces: number) =>
  amount / 10 ** decimalPlaces

export const formatCurrencyToDecimal = (amount: number, decimalPlaces: number) =>
  amount * 10 ** decimalPlaces
